import styled from "styled-components"
import CloudinaryImage from "components/cloudinary-image"

import { minWidth, eq } from "utils"

// Create a placeholder element to reserve space
export const Placeholder = styled.div`
  height: 5rem;
  width: 100%;
  display: block;

  ${minWidth.tablet`
    height: 8rem; // Adjust based on the actual height of the sticky product on tablet
  `}
`

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  margin: 0;
  background-color: #fff;
  color: #fff;
  z-index: 1000;
  width: 100%;
  bottom: 0;
  padding: 0;
  height: 5rem;
  transition: transform 0.3s ease-in-out; // Add smooth transition

  ${minWidth.tablet`
    left: 0;
    right: 0;
    height: unset;
    padding: 1.5rem 0;
    margin: 0 auto;
    max-width: 144rem;
    box-shadow: 0 0.1rem 0.7rem 0 rgb(145 145 145 / 35%);
  `}
`

export const ClickElement = styled.a`
  height: 100%;
  display: flex;
  align-items: baseline;
  flex-direction: row;
  justify-content: space-between;

  ${minWidth.tablet`
    align-items: stretch;
    background-color: #fff;
    color: #222;
    justify-content: center;
    width: fit-content;
    margin: auto;
  `}
`

export const InnerWrapper = styled.div`
  height: calc(100% - 1.9rem);
`

export const ClickableWrapper = styled.div`
  cursor: pointer;
`

export const Title = styled.h3`
  font-size: 2.2rem;
  font-weight: 500;
  text-align: center;
`

export const ProductTitle = styled.h3`
  font-weight: 500;
  padding-left: 1.5rem;
  padding-right: 1rem;
  text-align: center;
  font-size: 2rem;
  letter-spacing: 0;
  color: #000000;
  max-height: 100%;
  height: 100%;

  ${minWidth.tablet`
    font-size: 3rem;
    padding: 0 2rem;
    top: 0.3rem;
    color: #ec5d2a;
    margin-right: 0.4rem;
    position: relative;
  `}
`
export const StarsAndDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const Description = styled.div`
  display: none;
  padding-right: 0.5em;

  ${minWidth.tablet`
    display: block;
    font-size: 1.8rem;
  `}

  * {
    margin: 0;
  }
`

export const Button = styled.button`
  display: block;
  text-transform: uppercase;
  background-color: ${(props) => props.theme.colors.productsOrange};
  color: white;
  padding: 0.3rem 1.5rem;
  border: 0;
  font-size: 1.6rem;
  letter-spacing: 0.092rem;
  font-weight: 500;
  max-height: 100%;
  height: 100%;

  ${minWidth.tablet`
   text-transform: unset;
    margin-left: 3.2rem;
    padding: 1.5rem 4.6rem;
    letter-spacing: 0.2rem;
    height: auto;
    font-size: 1.6rem;
    border-radius: 3rem;
    letter-spacing: 0;
  `}

  ${eq("custom", true)`
    background-color: ${(props) => props.theme.colors.purpleMindfulness};
  `}

  ${eq("isClass", true)`
    background-color: ${(props) => props.theme.colors.classesTeal};
  `}
`

export const ArticleContainer = styled(Container)`
  justify-content: center;
  align-items: stretch;
  background-color: rgb(255, 255, 255);
  color: rgb(34, 34, 34);
  justify-content: center;
  width: 100%;
  height: auto;
  text-align: center;
  padding: 0.8rem 0;

  ${minWidth.tablet`
    padding: 1.5rem 0rem;
  `}
`

export const AnchorContainer = styled.a`
  display: flex;
  margin: auto;
  width: fit-content;
  align-items: center;
`

export const TextContainer = styled.div`
  margin: 0 1.5rem;
  text-align: center;
  color: #222;
  line-height: 1.2;
  font-size: 1.8rem !important;
  font-weight: 500;

  ${minWidth.tablet`
    margin: 0rem;
    text-align: left;
  `}
`

export const ImageContainer = styled(CloudinaryImage)`
  height: 7rem;
  min-width: 7rem;
  object-fit: cover;
  margin-left: 1.5rem;

  ${minWidth.tablet`
    margin-right: 1.5rem;
    margin-left: 0rem;
    min-width: 10rem;
  `}
`

export const ReadNext = styled.div`
  font-size: 1.2rem !important;
  color: #ec5d2a;
  font-weight: 500 !important;
  font-family: Maax;
  letter-spacing: 0.1rem;
  border: 0.1rem solid #ec5d2a;
  max-width: 10rem;
  margin: 0 auto 1.5rem auto;
  padding: 0.3rem;
  text-align: center;
`

export const ArticleTitle = styled.div`
  font-weight: 500;
  color: black;
`
